export type PendingApprovalItem = {
  readonly id: string;
  readonly title: string;
  readonly subtitle?: string;
  readonly requestedByLabel?: string;
  readonly status: 'pending' | 'approved' | 'rejected' | string;
};

export type PendingApprovalsListProps = {
  readonly items: readonly PendingApprovalItem[];
  readonly emptyLabel?: string;
  readonly selectedId?: string | null;
  readonly onSelect?: (id: string) => void;
  readonly testId?: string;
};

/**
 * Shared pending-approvals list for outbox replay + exception-grant SoD.
 * Anti-creep: not a BPM kit; claims UI must not count as SoD #2.
 */
export function PendingApprovalsList({
  items,
  emptyLabel = 'No pending approvals',
  selectedId = null,
  onSelect,
  testId = 'pending-approvals-list',
}: PendingApprovalsListProps) {
  if (items.length === 0) {
    return (
      <p data-testid={testId} className="pending-approvals-list pending-approvals-list--empty">
        {emptyLabel}
      </p>
    );
  }

  return (
    <ul data-testid={testId} className="pending-approvals-list">
      {items.map((item) => {
        const selected = item.id === selectedId;
        return (
          <li key={item.id}>
            <button
              type="button"
              className={
                selected
                  ? 'pending-approvals-list__item pending-approvals-list__item--selected'
                  : 'pending-approvals-list__item'
              }
              data-testid={`pending-approval-${item.id}`}
              aria-pressed={selected}
              onClick={() => onSelect?.(item.id)}
            >
              <span className="pending-approvals-list__title">{item.title}</span>
              {item.subtitle !== undefined ? (
                <span className="pending-approvals-list__subtitle">{item.subtitle}</span>
              ) : null}
              {item.requestedByLabel !== undefined ? (
                <span className="pending-approvals-list__meta">{item.requestedByLabel}</span>
              ) : null}
            </button>
          </li>
        );
      })}
    </ul>
  );
}
